import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import SimplePaperRelationships from '../components/SimplePaperRelationships';
import './SimplePaperRelationshipsPage.css';

const SimplePaperRelationshipsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPaperId, setCurrentPaperId] = useState('');
  // const [inputPaperId, setInputPaperId] = useState('');
  // const [recentPapers, setRecentPapers] = useState([]);
  // const [paperTitle, setPaperTitle] = useState('');
  const [prefetchedGraphData, setPrefetchedGraphData] = useState(null);

  useEffect(() => {
    // Check if we have state from the discovery page
    if (location.state?.paperId) {
      const { paperId, paperTitle: title, openalexWorkId, graphData, error } = location.state;
      console.log('Building graph from discovery page for:', paperId, title);
      
      // Log if we received an OpenAlex work ID
      if (openalexWorkId) {
        console.log('Received OpenAlex work ID:', openalexWorkId);
      }
      
      // Log if we received pre-fetched graph data
      if (graphData) {
        console.log('Received pre-fetched graph data:', graphData);
      }
      
      // Log if there was an error during graph building
      if (error) {
        console.log('Error from discovery page:', error);
      }
      
      setCurrentPaperId(paperId);
      // setInputPaperId(paperId);
      // setPaperTitle(title || '');
      
      // Store prefetched graph data if available
      if (graphData) {
        setPrefetchedGraphData(graphData);
      }
      
      addToRecentPapers(paperId);
      
      // Update URL params
      setSearchParams({ paperId: paperId });
      
      // Clear the state to prevent re-triggering (keep the search params)
      window.history.replaceState(null, '', `${location.pathname}?paperId=${paperId}`);
      return;
    }

    // Get paper ID from URL params if provided
    const paperId = searchParams.get('paperId');
    if (paperId) {
      setCurrentPaperId(paperId);
      // setInputPaperId(paperId);
      addToRecentPapers(paperId);
    }
  }, [searchParams, location.state, location.pathname, navigate, setSearchParams]);

  const handlePaperClick = (paperId) => {
    if (paperId) {
      setCurrentPaperId(paperId);
      // setInputPaperId(paperId);
      setSearchParams({ paperId: paperId });
      addToRecentPapers(paperId);
      // Clear prefetched data when clicking on a different paper
      setPrefetchedGraphData(null);
    }
  };

  const addToRecentPapers = (paperId) => {
    // Keep recent papers functionality (not stored in state to avoid warnings)
    console.log('Viewing paper:', paperId);
  };

  // const clearRecentPapers = () => {
  //   setRecentPapers([]);
  // };

  const handleExamplePaper = (exampleId) => {
    // setInputPaperId(exampleId);
    setCurrentPaperId(exampleId);
    setSearchParams({ paperId: exampleId });
    addToRecentPapers(exampleId);
  };

  // Example papers for demonstration
  const examplePapers = [
    {
      id: '1706.03762',
      title: 'Attention Is All You Need',
      description: 'The famous Transformer paper - great for seeing foundational AI research'
    },
    {
      id: '2010.11929',
      title: 'An Image is Worth 16x16 Words',
      description: 'Vision Transformer paper - shows how ideas evolve from text to vision'
    },
    {
      id: '1512.03385',
      title: 'Deep Residual Learning for Image Recognition',
      description: 'ResNet paper - highly influential computer vision work'
    }
  ];

  return (
    <div className="paper-relationships-page">

      {/* Example Papers */}
      {!currentPaperId && (
        <div className="examples-section">
          <h3>Try These Famous Papers</h3>
          <div className="example-papers">
            {examplePapers.map((paper, index) => (
              <div key={index} className="example-paper-card">
                <h4>{paper.title}</h4>
                <p>{paper.description}</p>
                <button 
                  onClick={() => handleExamplePaper(paper.id)}
                  className="try-example-btn"
                >
                  Explore This Paper
                </button>
                <div className="paper-id-display">
                  <code>{paper.id}</code>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Recent Papers */}
      {/* {recentPapers.length > 0 && (
        <div className="recent-section">
          <div className="recent-header">
            <h4>Recently Explored</h4>
            <button onClick={clearRecentPapers} className="clear-recent-btn">
              Clear History
            </button>
          </div>
          <div className="recent-papers">
            {recentPapers.map((paperId, index) => (
              <button
                key={index}
                onClick={() => handlePaperClick(paperId)}
                className={`recent-paper-btn ${paperId === currentPaperId ? 'active' : ''}`}
              >
                {paperId}
              </button>
            ))}
          </div>
        </div>
      )} */}

      {/* Main Content */}
      <div className="main-content">
        <div className="paper-relations-header">
          <button onClick={() => navigate('/search')} className="back-button">
            ← Back to Results
          </button>
        </div>
        <SimplePaperRelationships 
          paperId={currentPaperId}
          onPaperClick={handlePaperClick}
          prefetchedGraphData={prefetchedGraphData}
        />
      </div>
    </div>
  );
};

export default SimplePaperRelationshipsPage;